import { ApolloClient, InMemoryCache, from } from '@apollo/client';
import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import { retryLink } from '@betterment/graphql';

import { createErrorLink } from './links/errorLink';
import { httpLink } from './links/httpLink';
import { scalarsLink } from './links/scalarsLink';

import { navigate } from '../utils/pathHelpers';
import { urlBuilder } from '../utils/urlBuilder';

if (process.env.NODE_ENV !== 'production') {
  loadDevMessages();
  loadErrorMessages();
}

const LOGIN_PATH = '/plan_managers/sign_in';
const RETURN_TO_PARAM = 'return_to';

// Builds a new Apollo Client instance. This can be used in tests and
// Storybook stories to create isolated instances.
export const buildClient = () => {
  const cache = new InMemoryCache();
  const errorLink = createErrorLink(async () => {
    await cache.reset().finally(() => {
      const currentPath = window.location.pathname + window.location.search;
      navigate(LOGIN_PATH, { [RETURN_TO_PARAM]: currentPath });
    });
  });

  return new ApolloClient({
    link: from([retryLink, errorLink, scalarsLink, httpLink(urlBuilder.graphQL(), {})]),
    cache: new InMemoryCache(),
    connectToDevTools: true,
    defaultOptions: {
      query: {
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
      },
      mutate: {
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
      },
      watchQuery: {
        errorPolicy: 'all',
        fetchPolicy: 'cache-and-network',
      },
    },
  });
};

export const client = buildClient();
